import * as React from "react";

const Steps: React.FunctionComponent<{ totalSteps: number, currentStep: number }> = props => {
    return <ul className="landing-steps">
        {Array.from(new Array(props.totalSteps), (_, i) => i + 1).map((step_number) => <li key={`step_link_${step_number}`} className={(props.currentStep === step_number ? "active" : "")}>{step_number}</li>)}
    </ul>;
}

export default Steps;